import { Component, OnInit } from '@angular/core';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {
  status: boolean = false;
  status2: boolean = false;
  clickEvent(){
    this.status = !this.status;
  }
  clickEvent2(){
    this.status2 = !this.status2;
  }

  constructor(private tokenStorageService: TokenStorageService,
              private router: Router) { }

  ngOnInit() {
  }

  logout(){
    this.tokenStorageService.signOut();
  }

  resetPssword(){
    this.router.navigate(['/dashboard/reset'] );
  }
}
